import React, { createContext, useContext, useState, useEffect } from 'react';
import { APP_CONFIG } from '../config/constants';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showOnboarding, setShowOnboarding] = useState(false);

  useEffect(() => {
    // Always create a default user to bypass login
    const defaultUser = {
      id: 'local-user',
      name: 'Gardener',
      email: 'gardener@mindgarden.app',
    };
    setUser(defaultUser);

    // Check if onboarding has been completed, separate from auth
    try {
      const onboardingData = localStorage.getItem(APP_CONFIG.storage.onboarding);
      if (!onboardingData) {
        setShowOnboarding(true);
      }
    } catch (e) {
      console.error("Failed to read onboarding status from localStorage", e);
      setShowOnboarding(true);
    }

    setIsLoading(false);
  }, []);

  const completeOnboarding = (data) => {
    setShowOnboarding(false);
    try {
      localStorage.setItem(
        APP_CONFIG.storage.onboarding,
        JSON.stringify({ completed: true, completedAt: new Date().toISOString(), ...data })
      );
    } catch (e) {
      console.error("Failed to save onboarding status to localStorage", e);
    }
  };

  // Dummy logout function to prevent errors if it's called elsewhere.
  const logout = () => {
    console.log("Logout is disabled in this version.");
  };

  const value = {
    user,
    isLoading,
    isAuthenticated: true, // Always authenticated
    showLogin: false, // Never show login modal
    showOnboarding,
    completeOnboarding,
    logout,
    // Dummy functions for other auth methods to prevent errors
    signInWithGoogle: async () => console.warn('Sign-in disabled'),
    signInWithEmail: async () => console.warn('Sign-in disabled'),
    signUpWithEmail: async () => console.warn('Sign-up disabled'),
    setShowLogin: () => {},
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};